import { UnitSearchHeaderController } from './unit.search.header.controller';
import template from './unit.search.header.html';

export const unitSearchHeader: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: UnitSearchHeaderController,
  controllerAs: 'vm',
  template,
  restrict: 'A',
  scope: {
    houseName: '@',
    houseLocation: '@',
    houseCity: '@',
    objectId: '@',
    sectionId: '@',
    houseId: '@',
    defaultCurrency: '@',
  },
});
